import { ActionIcon, type ActionIconProps, Tooltip } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { IconDownload } from '@tabler/icons-react';

export interface DownloadButtonProps extends Omit<ActionIconProps, 'onClick'> {
  data: string | Blob;
  fileName: string;
  mimeType: string;
  icon?: Icon;
  tooltip?: string;
}

export function DownloadButton({
  data,
  fileName,
  mimeType,
  icon: IconComponent = IconDownload,
  tooltip = 'Download',
  loading,
  disabled,
  ...actionIconProps
}: DownloadButtonProps) {
  const handleClick = () => {
    const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Tooltip label={tooltip} withArrow>
      <ActionIcon disabled={disabled} loading={loading} onClick={handleClick} {...actionIconProps}>
        <IconComponent size={14} />
      </ActionIcon>
    </Tooltip>
  );
}
